import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Container,
  Typography,
  Grid,
  Paper,
  Chip,
  Box,
} from '@mui/material';

import type { Game } from '@shared/types';

import { getEndEditDate, getEndGameDateFormatted } from '@shared/utils/gameExpiration';
import styles from './game-header.module.scss';

interface GameHeaderProps {
  gameDefaults?: Game;
  activateDate: Date | null;
  editDayCount: number;
  gameDayCount: number;
}

const GameHeader: FC<GameHeaderProps> = ({
  gameDefaults,
  activateDate,
  editDayCount,
  gameDayCount,
}) => {
  const { t } = useTranslation();

  const formattedEndEditDate =
    activateDate !== null ? getEndEditDate(new Date(activateDate), editDayCount) : '';

  const formattedEndGameDate =
    activateDate !== null ? getEndGameDateFormatted(new Date(activateDate), gameDayCount) : '';

  return (
    <>
      <Typography variant="h4" component="h1" align="center" sx={{ fontWeight: 400, color: '#111827', mb: 0, mt: -2 }}>
        {gameDefaults?.title}
      </Typography>
      {/* <Typography variant="h6" align="center" sx={{ mb: 4, color: '#6b7280' }}>
        {t('client.minerTitle')}
      </Typography> */}

      {(formattedEndEditDate || formattedEndGameDate) && (
        <Grid container spacing={2} sx={{ mb: 2, justifyContent: 'center' }}>
          {formattedEndEditDate && (
            <Grid item xs={12} sm="auto">
              <Paper className={`${styles.dateInfoPaper} ${styles.editDatePaper}`}>
                <Chip label={t('clientAll.editUntil')} size="small" color="error" className={styles.dateChip} />
                <Typography variant="body2" sx={{ fontWeight: 500 }}>{formattedEndEditDate}</Typography>
              </Paper>
            </Grid>
          )}
          {formattedEndGameDate && (
            <Grid item xs={12} sm="auto">
              <Paper className={`${styles.dateInfoPaper} ${styles.gameDatePaper}`}>
                <Chip label={t('clientAll.availableUntil')} size="small" color="warning" className={styles.dateChip} />
                <Typography variant="body2" sx={{ fontWeight: 500 }}>{formattedEndGameDate}</Typography>
              </Paper>
            </Grid>
          )}
        </Grid>
      )}
    </>
  );
};

export default GameHeader; 